<template>
    <div class="col-md-12 justify-content-center mx-auto px-5">
        <table class="mx-auto my-2" style="width:100%;">
            <tbody class="colorabc1">
                <tr>
                    <td style="width:2%;">
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" class="bi bi-people-fill" viewBox="0 0 16 16">
                        <path d="M7 14s-1 0-1-1 1-4 5-4 5 3 5 4-1 1-1 1H7zm4-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6z"/>
                        <path fill-rule="evenodd" d="M5.216 14A2.238 2.238 0 0 1 5 13c0-1.355.68-2.75 1.936-3.72A6.325 6.325 0 0 0 5 9c-4 0-5 3-5 4s1 1 1 1h4.216z"/>
                        <path d="M4.5 8a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5z"/>
                        </svg>
                    </td>
                    <td style="width:98%;">
                        <p class="abc-title-main mb-0 pt-1"> {{__("traductionview.clients")}}</p>
                    </td>
                </tr>
            </tbody>
        </table>
        <div class="dashboardstyle pt-0">
            <table class="text-center abc-table mx-auto" style="width:100%;">
                <thead class="abc-title-table">
                    <tr style="border-bottom: 1px solid #3A9AF3;">
                        <th style="width:30%; vertical-align:middle">
                            {{__("recap.country")}}
                        </th>
                        <th style="width:10%; vertical-align:middle;">
                           {{__("recap.total_projects")}}
                        </th>
                        <th style="width:10%; vertical-align:middle;">
                            {{__("recap.ongoing_projects")}}
                        </th>
                        <th style="width:15%; vertical-align:middle;">
                            {{__("recap.finished_projects")}}
                        </th>
                        <th style="width:15%; vertical-align:middle;">
                            {{__("recap.to_do")}}
                        </th>
                        <th style="width:15%; vertical-align:middle;">
                            {{__("recap.staff")}}
                        </th>
                    </tr>
                </thead>
                <tbody id="ongoingproject" class="pb-3" style="font-size: 11px; display:block; max-height:450px; overflow:auto; margin-right:2px!important; margin-left:3px!important;">
                    <tr v-for="(customer, index) in customs" :key="index" style="border-bottom:solid rgb(206, 206, 206) 1px;">
                        <td style="vertical-align: middle; width:30%;" class="py-3">
                            {{ customer.name }}
                        </td>
                        <td style="vertical-align:middle; width:10%;">
                            {{ Math.round(customer.ongoing_projects + customer.finished_projects)  }}
                        </td>
                        <td style="vertical-align: middle; width:10%; text-transform:capitalize;">
                            {{ customer.ongoing_projects }}
                        </td>
                        <td style="vertical-align: middle; width:15%;">
                            {{ customer.finished_projects }}
                        </td>
                        <td style="vertical-align: middle; width:15%;">
                            {{ customer.to_do }}
                        </td>
                        <td style="vertical-align: middle; width:15%;">
                            {{ customer.staff }}
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
    export default {
        props: [
            'countries',
            'country',
            'token',
            'route',
        ],

        data() {
            return {
                customs:[],
                filtername:"",
                filterproject:"",
                filterstaff:"",
            }
        },

        mounted() {
            this.countries.forEach(customer =>
            {
                this.customs.push(customer)
            });
        },

        methods: {
    }
}

</script>